import { useTranslation } from 'react-i18next';
import React from 'react';

import { Button } from '@/components';

import './index.scss';

export const LoadFailed = ({ reload, loading = false }: { reload(): void; loading?: boolean }) => {
  const { t } = useTranslation();

  return (
    <div className="db-load-failed">
      <div>{t('LoadFailed.dvduvr')}</div>
      <Button onClick={reload} loading={loading} className="db-load-failedBtn">
        {t('LoadFailed.14f7jjt')}
      </Button>
    </div>
  );
};
